
const Customer = (state) => state.Customer;
const Customers = (state) => state.Customers;
const TotalInfo = (state) => state.TotalInfo;
export default { Customer, Customers, TotalInfo }